import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	addSchedule: {
		id: 'eoc-schedule.ui.list.add-schedule',
		defaultMessage: 'Add schedule',
		description: 'A button to create schedule.',
	},
	yourTeamSchedulesAppear: {
		id: 'eoc-schedule.ui.list.your-team-schedules-appear',
		defaultMessage: 'Your team’s schedules will appear here',
		description: 'Description for where schedules will appear .',
	},
	startBuildingSchedules: {
		id: 'eoc-schedule.ui.list.start-building-schedules',
		defaultMessage:
			'Start building schedules to make sure somone is always on the call and responding to alerts.',
		description: 'Description of what schedule are used for.',
	},
	readMoreAboutSchedules: {
		id: 'eoc-schedule.ui.list.read-more-about-schedules',
		defaultMessage: 'Read more about on-call schedules',
		description: 'A link to read more about schedules.',
	},
	seeOnCallOnceAdmin: {
		id: 'eoc-schedule.ui.list.see-on-call-once-admin',
		defaultMessage:
			'See who is on call in your team and when. Once your admin creates a schedule, it will appear here.',
		description: 'Explanation of what is the section used for and why can`t add schedule.',
	},
});
